import { render } from "./AccessRestricted.vue?vue&type=template&id=01a56238&ts=true"
import script from "./AccessRestricted.vue?vue&type=script&lang=ts"
export * from "./AccessRestricted.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__